/*
 * transfer util 穿梭框公共方法
 * author zhousheng
 */
const DEFAULT_BOX_HEIGHT = 264;
const HEADER_HEIGHT = 40;
const DOUBLE_BORDER_WIDTH = 2;
const SEARCH_HEIGHT = 40;
export const ITEM_HEIGHT = 32;
const heightReg = /^\d+/;
export const getBodyHeight = (styleObj, showSearch) => {
    var _a;
    let bodyHeight = DEFAULT_BOX_HEIGHT - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH;
    const { height } = styleObj;
    if (height === undefined || !heightReg.test(height)) {
        bodyHeight = showSearch ? bodyHeight - SEARCH_HEIGHT : bodyHeight;
    }
    else {
        const heightNum = Number((_a = heightReg.exec(height)) === null || _a === void 0 ? void 0 : _a[0]);
        bodyHeight = showSearch
            ? heightNum - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH - SEARCH_HEIGHT
            : heightNum - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH;
    }
    return bodyHeight;
};
